import { createFileRoute, Outlet } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import TabLayout from "src/components/base/tab-layout";
import { Tab, TabMenu } from "src/components/base/tab-menu";

/**
 * The properties for {@link ExitNodeTabs}
 */
export type ExitNodeTabsProps = {};

/**
 * Tabs for the exit node view
 */
export default function ExitNodeTabs(props: ExitNodeTabsProps) {
    const [t] = useTranslation("customer-exit-nodes");

    return (
        <TabLayout
            heading={t("heading.exit-nodes")}
            headingDescription={t("description.exit-nodes")}
            tabs={
                <TabMenu>
                    <Tab href={"/c/exitnodes/approved"}>{t("heading.approved")}</Tab>
                    <Tab href={"/c/exitnodes/pending"}>{t("heading.pending")}</Tab>
                </TabMenu>
            }
        >
            <Outlet />
        </TabLayout>
    );
}

export const Route = createFileRoute("/_customer/c/exitnodes/_exitnodes")({
    component: ExitNodeTabs,
});
